<template>
    <div v-if="visible" class="dialog-overlay">
        <div class="dialog-container">
            <button class="close-btn" @click="closeDialog"><i class="el-icon-close"></i></button>
            <div class="dialog-header">
                <!-- <i class="el-icon-search" style="position: absolute;left: 1rem;"></i> -->
                <input class="dialog-header-input" v-model="searchQuery" type="text" placeholder="输入关键词以搜索" @keyup.enter="search(true)" />
                <button class="search-btn" @click="search(true)">
                    <i class="el-icon-search" style="font-size: 1.5rem;color: white;"></i>
                    <!-- <svg t="1748586901778" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="37591" width="20" height="20"><path d="M42.666667 149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h256a21.333333 21.333333 0 0 1 0 42.666667H64a21.333333 21.333333 0 0 1-21.333333-21.333334z m917.333333 746.666667h-128a21.333333 21.333333 0 0 0 0 42.666667h128a21.333333 21.333333 0 0 0 0-42.666667zM64 554.666667h256a21.333333 21.333333 0 0 0 0-42.666667H64a21.333333 21.333333 0 0 0 0 42.666667z m554.666667 341.333333H64a21.333333 21.333333 0 0 0 0 42.666667h554.666667a21.333333 21.333333 0 0 0 0-42.666667z m241.673333-432.16A212.406667 212.406667 0 0 1 725.333333 512c-117.82 0-213.333333-95.513333-213.333333-213.333333s95.513333-213.333333 213.333333-213.333334 213.333333 95.513333 213.333334 213.333334a212.406667 212.406667 0 0 1-48.16 135.006666l84.58 84.573334a21.333333 21.333333 0 0 1-30.173334 30.173333zM896 298.666667c0-94.253333-76.413333-170.666667-170.666667-170.666667S554.666667 204.413333 554.666667 298.666667s76.413333 170.666667 170.666666 170.666666 170.666667-76.413333 170.666667-170.666666z" fill="#ffffff" p-id="37592"></path></svg> -->
                </button>
            </div>

            <div class="dialog-filter">   
                <VisualDatePicker @date-selected="handleDateSelection" @search="search(true)" />
            </div>

            <div class="dialog-body">
                <div v-for="(item, index) in dataList" :key="index" @click="goToArticle(item)" class="dialog-body-container">
                    <span style="width: 7%;">{{index + 1 + (page -1) * 20}}、</span>
                    <span style="width: 5%;">
                        <i class="el-icon-document"></i>
                    </span>
                    <div style="width: 80%;">
                        <div class="dialog-body-container-title" v-html="item.highlightedTitle"></div>
                        <div class="dialog-body-container-text" v-html="item.highlightedContent"></div>
                    </div>
                    <span style="width: 5%;margin-left: 3%;">
                        <i class="el-icon-back" style="color: white;"></i>
                    </span>
                </div>
                <p v-if="dataList.length < 1" style="margin: 2rem auto;color: #909399;font-weight: 300;font-size: .91rem;">暂无搜索结果 ～～</p>
            </div>

            <div class="dialog-footer">
                <div v-if="total > 1" style="display: flex; align-items: center;">
                    <button @click="prevPage" :disabled="page === 1">上一页</button>
                    <span style="margin: 0 .5rem;">{{ page }} / {{ Math.ceil(total / size) }}</span>
                    <button @click="nextPage" :disabled="page >= Math.ceil(total / size)">下一页</button>
                </div>
                <span style="display: flex;align-items: center;">
                    <svg t="1742527369835" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="104862" width="22" height="22"><path d="M616 64H408c-119.3 0-216 96.71-216 216v360c0 176.73 143.27 320 320 320s320-143.27 320-320V280c0-119.29-96.71-216-216-216z m168 576a272 272 0 1 1-544 0V280a168 168 0 0 1 168-168h92v113.3a56 56 0 0 0-44 54.7v80a56 56 0 0 0 112 0v-80a56 56 0 0 0-44-54.7V112h92a168 168 0 0 1 168 168zM512 238a42 42 0 0 1 42 42v80a42 42 0 0 1-84 0v-80a42 42 0 0 1 42-42z" fill="" p-id="104863"></path></svg>
                    请使用鼠标上下滑动查看
                </span>
                <span> 关键词命中：{{ total }} 条</span>
            </div>

            <!-- <div class="dialog-footer">
                <button @click="prevPage" :disabled="page === 1">上一页</button>
                <span>{{ page }} / {{ totalPages }}</span>
                <button @click="nextPage" :disabled="page >= totalPages">下一页</button>
            </div> -->
        </div>
    </div>
</template>

<script>
import VisualDatePicker from './DatePicker.vue'
import searchApi from '@/api/searchApi'
import getDeviceInfo from '@/utils/deviceInfo'

export default {
    components: {
        VisualDatePicker
    },
    props: {
        visible: Boolean,
        title: {
            type: String,
            default: "搜索"
        },
        columns: {
            type: Array,
            default: () => ["名称", "编号"]
        },
        // searchApi: Function
    },
    data() {
        return {
            searchQuery: "",
            dataList: [],
            page: 1,
            size: 20,
            total: 0,
            startDate: null,
            endDate: null,
            nowSearchRecordId: null,
        };
    },
    methods: {
        closeDialog() {
            this.$emit("update:visible", false);
        },
        async search(resetPage = false) {
            if (resetPage) this.page = 1;

            const deviceInfo = JSON.stringify(getDeviceInfo())
          
            const query = {
                query: this.searchQuery,
                page: this.page,
                pageSize: this.size,
                startDate: this.startDate, // 格式如 "2024-01-01"
                endDate: this.endDate,      // 格式如 "2024-12-31"
                uaInformation: deviceInfo
            }
            console.log(query);
            searchApi.search(query).then(res => {
                // this.dataList = res.data
                // this.totalPages = res.totalPages
                console.log(res.data.result)
                console.log(res.data.recordId)
                // this.dataList = res.data.result.hits
                this.nowSearchRecordId = res.data.recordId

                this.dataList = res.data.result.hits.map(item => {
                    return {
                        ...item,
                        highlightedTitle: item._formatted.title
                        .replace(/<em>/g, '<span style="color:green; font-weight:bold">')
                        .replace(/<\/em>/g, '</span>'),
                        highlightedContent: item._formatted.content
                        .replace(/<em>/g, '<span style="color:green; font-weight:bold">')
                        .replace(/<\/em>/g, '</span>')
                    }
                });


                if(res.data.result.offset && res.data.result.offset  > 0) {
                    this.page = res.data.result.offset/res.data.result.limit + 1
                } else {
                    this.page = 1
                }
                this.size = res.data.result.limit;
                this.total = res.data.result.estimatedTotalHits;
            })
        },
        async goToArticle(item) {
            if (!this.nowSearchRecordId) return; // 如果没有记录ID，直接返回

            try {
                const dataForm = {
                    articleId: item.id
                }
                const res = await searchApi.clickArticle(this.nowSearchRecordId, dataForm);

                if (res.code === 200) {
                    // await this.$router.push({
                    //     path: '/article',
                    //         query: {
                    //         key: item.metadataName
                    //     }
                    // })

                    window.open(
                        this.$router.resolve({
                            path: '/article',
                            query: { key: item.metadataName }
                        }).href,
                        '_blank'
                    )

          

                    // await this.closeDialog()
                } else {
                    console.error('点击文章失败:', res.message || '未知错误');
                    // 可选：提示用户
                    // this.$message.error(res.message || '加载文章失败，请重试');
                }
            } catch (error) {
                console.error('请求过程中发生错误:', error)
                // 可选：提示用户
                // this.$message.error('网络异常，请检查连接后重试');
            }
        },
        selectItem(item) {
            // this.$emit("confirm", item);
            this.closeDialog()
        },
        prevPage() {
            if (this.page > 1) {
                this.page--
                this.search()
            }
        },
        nextPage() {
            if (this.page < (this.total / this.size)) {
                this.page++
                this.search();
            }
        },
        handleDateSelection(range) {
            console.log('选择的日期范围:', range)
            this.startDate =  range.start
            this.endDate =  range.end
            // 执行数据筛选等操作
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 111;
}

.dialog-container {
    background: white;
    padding: 1rem;
    border-radius: 8px;
    width: 60vw;
    min-height: 87vh;
    max-width: 38rem;
    min-width: 36rem;
    position: relative;
    top: -2vh;
}

.dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.close-btn {
    background: none;
    border: none;
    font-size: 2.5rem;
    cursor: pointer;
    position: absolute;
    right: -3rem;
    top: 1rem;
    color: white;
}

.close-btn:hover {
    color: #74c8a3;
}

.dialog-header-input {
    width: 100%;
    padding: .8rem;
    padding-left: 2.8rem;
    border: .1rem #74c8a3 solid;
    border-radius: .3rem;
    font-size: 1rem;
}

.dialog-header-input:hover {
    border: .1rem #74c8a3 solid;
}

.dialog-header-input:focus {
    border: .1rem #74c8a3 solid;
}

.dialog-footer {
    position: absolute;
    bottom: 0;
    right: 1rem;
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 1rem;
    background: white;
    width: calc(100% - 2rem);
    box-sizing: border-box;
    padding: .5rem;
}

.dialog-filter {
    display: flex;
    justify-content: space-between;
    margin-top: .5rem;
    align-items: center;
    font-size: .7rem;
}


.dialog-body {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    border-top: #88ba96 solid .05rem;
    margin-top: 1rem;
    background: #f9fafc;
    height: 100%;
    min-height: 34vh;
    max-height: 74vh;
    overflow: scroll;
    padding: 1rem;
    box-sizing: border-box;
}

.dialog-body-container {
    width: 100%;
    padding: .5rem;
    background: white;
    border-radius: .5rem;
    min-height: 5.6rem;
    max-height: 6.2rem;
    display: flex;
    align-items: center;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 四边均衡阴影 */
    margin: .5rem 0;
    cursor: pointer;
}

.dialog-body-container-title {
    display: -webkit-box;
    /* 使用弹性盒子模型，使得-webkit-line-clamp有效 */
    -webkit-box-orient: vertical;
    /* 子元素垂直排列 */
    -webkit-line-clamp: 1;
    /* 显示的行数 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 超出部分用省略号表示 */
    line-height: 1.5;
    /* 根据实际情况调整行高 */
    max-height: calc(1.5 * 2rem);
    /* 行高乘以显示的行数，确保最多显示两行 */
    margin-bottom: .2rem;
    margin-top: 0;
    font-weight: 500;
    font-size: .8rem;
}

.dialog-body-container-text {
    display: -webkit-box;
    /* 使用弹性盒子模型，使得-webkit-line-clamp有效 */
    -webkit-box-orient: vertical;
    /* 子元素垂直排列 */
    -webkit-line-clamp: 4;
    /* 显示的行数 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 超出部分用省略号表示 */
    line-height: 1.5;
    /* 根据实际情况调整行高 */
    max-height: calc(1.5 * 2.8rem);
    /* 行高乘以显示的行数，确保最多显示两行 */
    margin-bottom: .2rem;
    margin-top: 0;
    font-size: .7rem;
    font-weight: 300;
    color: #909090;
}

.dialog-body-container:hover {
    background: #74c8a3;
    color: white;

    .dialog-body-container-text {
        color: white;
    }
}

.search-btn {
    position: absolute;
    right: 0;
    padding: .7rem;
    background: #74c8a3;
    border: none;
    border-radius: .2rem .3rem .3rem .2rem;
}


@media screen and (max-width: 768px) {
    .dialog-container {
        width: 88vw;
        max-height: 72vh;
        min-width: 320px;
        top: 0;
        left: 0;
        padding: 0.8rem;
        border-radius: 0;
        border: none;
        box-shadow: none;
    }

    .close-btn {
        position: absolute;
        right: 0rem;
        top: -2.5rem;
        font-size: 2.2rem;
        z-index: 10;
    }

    .dialog-header {
        display: flex;
        align-items: center;
        padding: 0.5rem 0;
    }

    .dialog-header-input {
        flex: 1;
        font-size: 1rem;
        padding: 0.6rem 0.8rem 0.6rem 2rem;
        border-radius: 0.6rem;
        background-color: #f5f5f5;
    }

    .dialog-body {
        max-height: calc(72vh - 6rem);
        overflow-y: auto;
        padding: 0.5rem 0;
    }

    .dialog-body-container {
        margin: .5rem .2rem;
    }


    .dialog-body-container-title {
        font-size: .9rem;
        font-weight: 600;
        -webkit-line-clamp: 1;
        line-height: 1.4;
    }

    .dialog-body-container-text {
        font-size: 0.8rem;
        color: #666;
        -webkit-line-clamp: 3;
    }

    .dialog-footer {
        gap: .5rem;
        flex-wrap: wrap;
    }

    .search-btn {
        position: absolute;
        right: 0;
        padding: .5rem;
        background: #74c8a3;
        border: none;
        border-radius: .2rem .8rem .8rem .2rem;
    }
}


</style>